<template>
  <v-container fluid class="pricelist-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Price List</v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Price List</p>
                        <v-text-field
                          class="mb-4"
                          v-model="pricelist.pricelistcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Pricelist Code"
                          persistent-hint
                          single-line hint="Enter the pricelist Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="pricelist.pricelistname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Pricelist Name"
                          persistent-hint
                          single-line hint="Enter the pricelist name">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items=pricelisttype
                          v-model="pricelist.pricelisttype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the pricelist type">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="[{text: 'None', value: null}, ...saleschannels.map(x => {return {text: x.channelname, value: x._id};})]"
                          v-model="pricelist.channelid"
                          outlined
                          dense
                          placeholder="Channel"
                          persistent-hint
                          single-line hint="Please choose the channel">
                        </v-select>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/pricelist/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertPriceList()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      pricelist: {},
      pricelisttype: ['Sales', 'Purchasing', 'Online', 'Other'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
    ...mapActions('PriceList', ['createPriceListRequest','getPriceListsRequest']),
    checkError(){
      if(!this.pricelist.pricelistcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.pricelist.pricelistname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.pricelist.pricelisttype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertPriceList() {
      if(!this.checkError()) return;
      await this.createPriceListRequest(this.pricelist)
      router.push('/pricelist/list')
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.pricelist.pricelistimage = file;
      this.pricelist.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('PriceList', ['isReceiving']),
    ...mapState('SalesChannel', ['saleschannels']),
  },
  async created(){
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
